
import { Component, Prop, PropSync, Ref, Vue } from 'nuxt-property-decorator'
import { MediaType } from '../rmrk/types'
import { resolveMedia } from '../rmrk/utils'
import { BaseMintedCollection as MintedCollection } from './types'
import { NeoField } from '@kodadot1/brick'

const components = {
  Auth: () => import('@/components/shared/Auth.vue'),
  MetadataUpload: () => import('@/components/shared/DropUpload.vue'),
  BasicInput: () => import('@/components/shared/form/BasicInput.vue'),
  BasicNumberInput: () =>
    import('@/components/shared/form/BasicNumberInput.vue'),
  CollectionSelect: () => import('@/components/base/CollectionSelect.vue'),
  NeoField,
}

@Component({ components })
export default class BaseTokenForm extends Vue {
  @Prop({ type: String, default: 'context' }) label!: string
  @Prop({ type: Array, default: () => [] }) collections!: MintedCollection[]
  @Prop({ type: Boolean, default: true }) hasCopies!: boolean
  @Prop({ type: Boolean, default: false }) showExplainerText!: boolean

  @PropSync('name', { type: String }) vName!: string
  @PropSync('description', { type: String }) vDescription!: string
  @PropSync('file', { type: Blob }) vFile!: Blob | null
  @PropSync('selectedCollection') vSelectedCollection!: MintedCollection | null
  @PropSync('copies', { type: Number }) vCopies!: number
  @PropSync('secondFile', { type: Blob }) vSecondFile!: Blob | null
  @Ref('nftName') readonly nftName
  @Ref('upload') readonly upload

  public checkValidity() {
    const nftNameValid = this.nftName.checkValidity()
    const uploadValid = this.upload.checkValidity()
    return nftNameValid && uploadValid
  }

  get clickableMax() {
    return Infinity
    // return (this.max || Infinity) - this.alreadyMinted
  }

  get fileType() {
    return resolveMedia(this.vFile?.type)
  }

  get secondaryFileVisible() {
    const fileType = this.fileType
    return ![MediaType.UNKNOWN, MediaType.IMAGE].some((t) => t === fileType)
  }
}
